import _ from 'lodash';

export const userRole = {
    ADMIN: 'admin',
    DOCTOR: 'doctor',
    PATIENT: 'patient',
    VMA: 'vma',
};

export function createRole(authState) {
    if (_.get(authState, 'login.user.role', '') === userRole.ADMIN) {
        const isSuperAdmin = _.get(authState, 'login.user.isSuperAdmin', false);
        return new Role('admin', true, true, isSuperAdmin);
    }

    if (_.get(authState, 'login.user.role', '') === userRole.DOCTOR) return new Role(userRole.DOCTOR, _.get(authState, 'login.user.isAccountApproved', false));

    if (_.get(authState, 'login.user.role', '') === userRole.PATIENT) {
        return new Role(
            userRole.PATIENT,
            _.get(authState, 'login.user.doctor', false),
            _.get(authState, 'login.user.profileNotFilledStage', false),
        );
    }

    if (_.get(authState, 'login.user.role', '') === userRole.VMA) return new Role(userRole.VMA, _.get(authState, 'login.user.isAccountApproved', false));

    return new Role('', true);
}

export function getNextPathOnRole(role) {
    if (role.isDoctor() && !role.isFullAccess()) {
        return '/profile';
    } if (role.isDoctor()) {
        return '/home';
    } if (role.isPatient() && !role.isProfileFilled()) {
        return '/fillProfile';
    } if (role.isPatient() && !role.isFullAccess()) {
        return '/home';
    } if (role.isPatient()) {
        return '/home';
    } if (role.isAdmin()) {
        return '/admin';
    } if (role.isVma()) {
        return '/messages';
    } if (role.isGuest()) {
        return '/';
    }
}

export default class Role {
    constructor(role, fullAccess, profileNotFilledStage, isSuperAdmin) {
        this.role = role;
        this.fullAccess = fullAccess;
        this._isSuperAdmin = isSuperAdmin;
        this.profileNotFilledStage = profileNotFilledStage;
    }

    isGuest() {
        return !this.role;
    }

    isPatient() {
        return this.role === userRole.PATIENT;
    }

    isProfileFilled() {
        return !this.profileNotFilledStage;
    }

    isAdmin() {
        return this.role === userRole.ADMIN;
    }

    isSuperAdmin() {
        return this.isAdmin() && this._isSuperAdmin;
    }

    isDoctor() {
        return this.role === userRole.DOCTOR;
    }

    isVma() {
        return this.role === userRole.VMA;
    }

    oneOf(roles) {
        return roles.includes(this.role);
    }

    isFullAccess() {
        return this.fullAccess;
    }

    getPlainRole() {
        return this.role;
    }
}



// WEBPACK FOOTER //
// ./src/components/helpers/Role.js